// enum for time sheet status
enum enmTsStatus {
    Pending = 0,
    Aproved=1,
    Rejected=2
}
export default enmTsStatus;